import { brandTitle, BrandTitle, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCreateVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCreateVO.validationSchema()
  );

  constructor(readonly value: RoomBrandCreate) {
    JsonSchemaValidator.assert(RoomBrandCreateVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandTitle"],
      properties: {
        roomId,
        brandTitle
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCreate {
  roomId: RoomId;
  brandTitle: BrandTitle;
}
